export const VIEW_MORE = 'view_more'
